import { useCallback } from 'react';
import {
  getPurchaseOrderDetailsModalConfigWithDeepLink,
  getPurchaseOrderRelativeUrl,
} from 'src/utils/purchaseUtils';
import { ActionOutboxEntityType } from 'src/WebApiController';

import { useEntityActions } from './useEntityActions';

/**
 * Hook for purchase-specific actions like opening purchase modals.
 */
export const usePurchaseActions = () => {
  const { loadEntityAndOpenModal } = useEntityActions();

  const openPurchaseModal = useCallback(
    (
      purchaseId: number | string,
      dataFields: string[] = [],
      mouseEvent?: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
      if (mouseEvent && (mouseEvent.metaKey || mouseEvent.ctrlKey)) {
        mouseEvent.preventDefault();
        const url = getPurchaseOrderRelativeUrl(purchaseId);
        window.open(url, '_blank');
        return;
      }
      const getPurchaseModalConfig = (id: number | string) => {
        return getPurchaseOrderDetailsModalConfigWithDeepLink(id);
      };

      loadEntityAndOpenModal(
        ActionOutboxEntityType.Purchase,
        purchaseId,
        null,
        false,
        dataFields,
        false,
        false,
        getPurchaseModalConfig
      );
    },
    [loadEntityAndOpenModal]
  );

  return {
    openPurchaseModal,
  };
};
